<template>
  <naj-box :title="isSupervisionDocument?local.cessationForm.supervisorTittle:local.cessationForm.tittle">
    <v-row>
      <v-col
        v-if="!isSupervisionDocument"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.cessationForm.name"
          :value.sync="formModel.cessationName"
          :validates="`${required ? 'required|arabic_letters|isIdAllowed' : ''}`"
        ></naj-input>
      </v-col>
      <v-col
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="isSupervisionDocument?local.cessationForm.cessationSupervisorType:local.cessationForm.cessationType"
          :value.sync="formModel.cessationTypeId"
          :items="cessationTypes"
          item-value="id"
          item-text="name"
          :validates="`${required ? 'required' : ''}`"
          @change="resetForm"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 1"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.cessationForm.judgmentNumber"
          :value.sync="formModel.cessationJudgmentNumber"
          :validates="`${required ? 'required|' : ''}long`"
          @input="retrieved=false"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId == 1 && !retrieved"
        lg="2"
        cols="6"
        class="d-flex align-center"
      >
        <naj-button
          square
          inputs-alignment
          :disabled="!formModel.cessationJudgmentNumber"
          :loading="loading"
          @click="getCourtAndSubCircle"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 1"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.cessationForm.courts"
          :value.sync="formModel.cessationCourtId"
          :items="allCourts"
          item-value="id"
          item-text="name"
          :disabled="true"
          :validates="`${required ? 'required' : ''}`"
          @change="getAllCourtSubCircles(formModel.cessationCourtId)"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 1"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.cessationForm.courtSubCircles"
          :value.sync="formModel.cessationSubCircleId"
          :items="allCourtSubCircles[formModel.cessationCourtId]"
          :disabled="true"
          item-value="id"
          item-text="name"
          :validates="`${required ? 'required' : ''}`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 2"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.cessationForm.deedNumber"
          :value.sync="formModel.cessationDeedNumber"
          :validates="`${required ? 'required|' : ''}long|max:14`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 2"
        lg="3"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.cessationForm.issuer"
          :value.sync="formModel.cessationIssuer"
          :validates="`${required ? 'required|arabic_letters' : ''}`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 2"
        lg="6"
        cols="12"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.cessationForm.deedDate"
          :value.sync="formModel.cessationDeedDate"
          :validates="`${required ? 'required' : ''}`"
        ></naj-input>
      </v-col>
      <v-col
        v-show="formModel && formModel.cessationTypeId && formModel.cessationTypeId == 3"
        lg="6"
        cols="12"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.cessationForm.other"
          :value.sync="formModel.cessationOther"
          :validates="`${required && formModel && formModel.cessationTypeId && formModel.cessationTypeId == 3 ? 'required|arabic_letters' : ''}`"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>
import najButton from '@/components/shared/naj-button/naj-button.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapActions } = createNamespacedHelpers('LawsuitModule');
export default {
  components: { najButton },
  inject: ['$validator'],
  props: ['formModel', 'required', 'isSupervisionDocument'],
  data() {
    return {
      loading: false,
      retrieved: false,
    };
  },
  computed: { ...mapLUTState(['cessationTypes', 'allCourts', 'allCourtSubCircles']) },
  watch: {
    'formModel.cessationJudgmentNumber'() {
      this.$set(this.formModel, 'cessationCourtId', null);
      this.$set(this.formModel, 'cessationSubCircleId', null);
    },
  },
  mounted() {
    this.getCessationTypes();
    this.getAllCourts();
    if (this.formModel && this.formModel.cessationCourtId)
      this.getAllCourtSubCircles(this.formModel.cessationCourtId);
    this.retrieved = this.formModel.cessationCourtId && this.formModel.cessationSubCircleId;
  },
  methods: {
    ...mapLUTActions(['getCessationTypes', 'getAllCourts', 'getAllCourtSubCircles']),
    ...mapActions(['getCourtAndSubCircleByJudgementCode']),

    resetForm() {
      this.$set(this.formModel, 'cessationJudgmentNumber', null);
      this.$set(this.formModel, 'cessationCourtId', null);
      this.$set(this.formModel, 'cessationDeedNumber', null);
      this.$set(this.formModel, 'cessationIssuer', null);
      this.$set(this.formModel, 'cessationSubCircleId', null);
      this.$set(this.formModel, 'cessationDeedDate', null);
      this.$set(this.formModel, 'cessationOther', null);
      this.$set(this, 'retrieved', false);
    },
    getCourtAndSubCircle() {
      this.loading = true;
      this.retrieved = false;
      this.getCourtAndSubCircleByJudgementCode(this.formModel.cessationJudgmentNumber)
        .then((res) => {
          if (res) {
            this.$set(this.formModel, 'cessationCourtId', res.CourtId);
            this.getAllCourtSubCircles(this.formModel.cessationCourtId);
            this.$set(this.formModel, 'cessationSubCircleId', res.SubCircleID);
            this.toaster.success(this.local.common.verificationSucceeded);
            this.retrieved = true;
          }
          else {
            this.toaster.error(this.local.common.verificationFailed);
          }
        })
        .catch(() => {
          this.toaster.error(this.local.common.verificationFailed);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

};
</script>

<style scoped>
</style>
